export const RESET_STORE = 'root/RESET_STORE'

export function resetStore() {
  return {
    type: RESET_STORE,
  }
}
